'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormContext } from 'react-hook-form';
import { getAriaLabel } from '@bridge/utils';
import { FieldShell } from './FieldShell';
import { getFieldIds } from './utils';
import type { FieldValues } from 'react-hook-form';
import type { BaseComponentProps, BaseFieldProps } from './types';
export type InputComponentProps = BaseComponentProps<React.ElementType> & {
  placeholder?: string;
  /** HTML input type (e.g. 'text', 'email', 'number'). Passed through to the underlying input element. */
  type?: string;
};
interface InputFieldProps<TFieldValues extends FieldValues> extends BaseFieldProps<TFieldValues> {
  InputComponent: React.ElementType;
  componentProps: InputComponentProps;
}
export function InputField(t0) {
  const $ = _c(27);
  const {
    field,
    fieldConfig,
    fieldState,
    InputComponent,
    componentProps,
    labelSize
  } = t0;
  const formContext = useFormContext();
  let componentDisabled;
  let id;
  let restComponentProps;
  if ($[0] !== componentProps) {
    ({
      id,
      disabled: componentDisabled,
      ...restComponentProps
    } = componentProps);
    $[0] = componentProps;
    $[1] = componentDisabled;
    $[2] = id;
    $[3] = restComponentProps;
  } else {
    componentDisabled = $[1];
    id = $[2];
    restComponentProps = $[3];
  }
  const isDisabled = field.disabled || componentDisabled;
  let t1;
  if ($[4] !== fieldConfig || $[5] !== fieldState || $[6] !== id) {
    t1 = getFieldIds(fieldConfig, fieldState, id);
    $[4] = fieldConfig;
    $[5] = fieldState;
    $[6] = id;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const ids = t1;
  const t2 = ids.describedBy;
  const t3 = ids.isInvalid;
  let t4;
  if ($[8] !== fieldConfig.label) {
    t4 = getAriaLabel(fieldConfig.label);
    $[8] = fieldConfig.label;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = field.value ?? "";
  let t6;
  if ($[10] !== InputComponent || $[11] !== field || $[12] !== formContext || $[13] !== ids.describedBy || $[14] !== ids.fieldId || $[15] !== ids.isInvalid || $[16] !== isDisabled || $[17] !== restComponentProps || $[18] !== t4 || $[19] !== t5) {
    t6 = <InputComponent {...field} {...restComponentProps} aria-describedby={t2} aria-invalid={t3} aria-label={t4} disabled={isDisabled} formContext={formContext} id={ids.fieldId} value={t5} />;
    $[10] = InputComponent;
    $[11] = field;
    $[12] = formContext;
    $[13] = ids.describedBy;
    $[14] = ids.fieldId;
    $[15] = ids.isInvalid;
    $[16] = isDisabled;
    $[17] = restComponentProps;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== fieldConfig || $[22] !== fieldState || $[23] !== ids || $[24] !== labelSize || $[25] !== t6) {
    t7 = <FieldShell fieldConfig={fieldConfig} fieldState={fieldState} ids={ids} labelSize={labelSize}>{t6}</FieldShell>;
    $[21] = fieldConfig;
    $[22] = fieldState;
    $[23] = ids;
    $[24] = labelSize;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}